import { useEffect, useRef, useState } from 'react'
import { SECTIONS, SECTION_THEMES } from '../config'

export default function Nav({ active }) {
  const activeTheme = SECTION_THEMES[active] || SECTION_THEMES.home

  return (
    <nav
      data-testid="floating-nav"
      className="fixed left-1/2 top-4 z-50 w-[95vw] max-w-max -translate-x-1/2 md:top-5"
    >
      <ul
        className="no-scrollbar flex items-center gap-1 overflow-x-auto rounded-[2rem] border px-1.5 py-1.5 backdrop-blur-md transition-colors duration-300 md:justify-center md:rounded-full"
        style={{
          borderColor: activeTheme.dark ? 'rgba(255,255,255,0.16)' : 'rgba(0,0,0,0.1)',
          background: activeTheme.dark ? 'rgba(10,13,18,0.6)' : 'rgba(255,255,255,0.6)',
        }}
      >
        {SECTIONS.map((s) => {
          const isActive = active === s.id
          const theme = SECTION_THEMES[s.id] || activeTheme
          return (
            <li key={s.id} className="shrink-0">
              <a
                href={`#${s.id}`}
                data-testid={`nav-link-${s.id}`}
                aria-current={isActive ? 'true' : undefined}
                className="font-display block rounded-full px-3 py-1.5 text-[11px] font-medium transition-all duration-200 sm:px-3.5 sm:text-xs md:px-4"
                style={{
                  color: isActive
                    ? theme.activeText
                    : activeTheme.dark
                      ? 'rgba(255,255,255,0.65)'
                      : 'rgba(0,0,0,0.55)',
                  background: isActive ? theme.accent : 'transparent',
                }}
              >
                {s.label}
              </a>
            </li>
          )
        })}
      </ul>
    </nav>
  )
}
